import React from 'react'
import PropTypes from "prop-types"
import {  Glyphicon, FormGroup, FormControl, ControlLabel } from 'react-bootstrap'

import { getStatusValue } from './TripStatus'

import { getText } from '../lib/text.js'

const fieldName = (k) => (
  {
    name         : getText("Apodo"),
    realName     : getText("Apodo (pinyin)"),
    leaderName   : getText("Nombre del líder"),
    officialName : getText("Nombre oficial (en pinyin)"),
    wechat       : getText("WeChat ID"),
    email        : getText("Email"),
    origin       : getText("Ciudad de origen (¿de dónde es?)"),
    title        : getText("Título"),
    pGestion     : getText("Gº de Gestión (0 a 1)"),
  }[k] || k
)

const mandatoryFieldStatus = {
  leaderName: getStatusValue("bond_sent"),
  officialName: getStatusValue("bond_sent"),
  realName: getStatusValue("new") + 1
}

const fieldIsMissing = (trip, k, v) => (
  !v && mandatoryFieldStatus[k]
  && trip.status >= mandatoryFieldStatus[k]
)

const Field = ({ trip, k, v, onChange, italic }) => {
  const missing = fieldIsMissing(trip, k, v)

  return (
    <FormGroup
      controlId={k}
      validationState={missing ? "error" : "none"}
    >
      <ControlLabel>
        {fieldName(k)}
        {missing && (<i> Obligatorio</i>)}
      </ControlLabel>
      <FormControl
        type="text"
        value={v || ""}
        style={italic ? { fontStyle: "italic" } : {}}
        onChange={evt => onChange(evt.target.value)}
      />
      {
        missing && (
          <FormControl.Feedback>
            <Glyphicon glyph="warning-sign" />
          </FormControl.Feedback>
        )
      }
    </FormGroup>
  )
}

export const FauxField = ({ label, value }) => (
  <FormGroup>
    <ControlLabel>
      {label}
    </ControlLabel>
    <FormControl
      type="text"
      value={value}
      style={{ fontStyle: "italic" }}
      disabled
    />
  </FormGroup>
)

export default Field
